import { Modal, Tutorial, Utils } from 'common';

const { TutorialPosition } = Tutorial;
const { ModalButtonActionType } = Modal;
const { Logger, Session, Util } = Utils;

export default [
	{
		title: 'Welcome!',
		message:
			'<p>The <b>History</b> page lets you refund unused postage, create return shipping labels, schedule package pickups, and more.</p></br><p>Click <b>Next</b> to learn how to get started.',
		width: 550,
		position: TutorialPosition.Center,
	},
	{
		title: 'Search and Filters',
		message:
			"<p>Use the left panel to search or filter your history to find exactly what you're looking for.</p>",
		width: 340,
		element: '.search-input-wrapper.with-advanced-search',
		position: TutorialPosition.Right,
		showArrow: true,
	},
	{
		title: 'Toolbar',
		message:
			'<p>Use the toolbar to take actions like refunding an unused print or scheduling a package pickup.</p>',
		width: 360,
		element: '.refund-toolbar-button',
		position: TutorialPosition.Bottom,
		showArrow: true,
	},
	{
		title: 'Learn More',
		message:
			'<p>If you still have questions or want to learn about advanced features, click <b>Learn More</b>.</p></br><p>Otherwise, click <b>Close</b> to get started.</p>',
		width: 552,
		position: TutorialPosition.Center,
		buttons: [
			{
				text: 'Close',
				type: ModalButtonActionType.End,
			},
			{
				text: 'Learn More',
				onClick: () => {
					Util.openHelpCenter('22872397639707');

					Logger.logToServer({
						category: 'tutorial_info',
						action: 'learn_more',
					});
				},
			},
		],
	},
];
